import { useContext } from "react";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";

// Components
import { getDefaultTopLayout } from "../../components/service-pages/constants/company-pages-methods";
import AppImg from "../../components/utils/AppImg";
import Typography from "@vahak/core-ui/dist/components/Typography";
import Button from "@vahak/core-ui/dist/components/Button";

//Constants
import { ROUTES } from "@vahak/core/dist/constants/routeStrings";

//AppContext
import { AppContext } from "@vahak/core/dist/app-context";
import { GetServerSideProps } from "next";
import NoIndexHeader from "../../components/seo-header/NoIndexHeader";

export default function Forum() {
    const router = useRouter();
    const { isPhoneVerified } = useContext(AppContext);
    return (
        <>
            <NoIndexHeader />
            <div
                style={{
                    height: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                    padding: "10px"
                }}
            >
                <div>
                    <AppImg src={`discontinued.svg`} layout="fixed" width="240px" height="240px" />
                </div>
                <div style={{ maxWidth: "800px" }}>
                    <Typography size="l" align="center" as="p" weight="bold">
                        We have discontinued this forum. However if you have any concern or query, please reach out to
                        our customer care
                    </Typography>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", maxWidth: "300px", width: "100%" }}>
                    <Button onClick={() => router.push(isPhoneVerified ? ROUTES.dashboard.getUrl() : "/")}>
                        Go Home
                    </Button>
                    <Button onClick={() => router.push("/contact-us")}>Contact Us</Button>
                </div>
            </div>
        </>
    );
}

Forum.getLayout = getDefaultTopLayout;

export const getServerSideProps: GetServerSideProps = async ({ locale }: any) => {
    return {
        props: {
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("staticPage")))
        }
    };
};
